module.exports = __webpack_public_path__ + "static/img/logo-xxl.a5e7d93.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo-xxl.png
// module id = nFYM
// module chunks = 1